<script setup lang="ts">
    defineProps<{
        text: string;
    }>();
</script>

<template>
    <span class="px-[5px] py-[3px] ml-1 text-[9px] font-semibold text-white rounded-md bg-branding-peppol-blue uppercase text-center leading-[12px]">
        {{ text }}
    </span>
</template>
